(function () {
  'use strict';

  var HIDDEN_CLASS = 'cwc_testimonials__card--hidden';
  var RUNNING_CLASS = 'cwc_testimonials__carousel--running';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* === Grid: Show More === */
  function initShowMore(sectionEl) {
    var button = sectionEl.querySelector('.cwc_testimonials__more');
    var grid = sectionEl.querySelector('.cwc_testimonials__grid');
    if (!button || !grid) return;
    if (button.dataset.cwcReady) return;
    button.dataset.cwcReady = 'true';

    var wrapper = button.parentElement;
    var perLoad = parseInt(button.dataset.perLoad, 10) || 3;

    function hiddenCards() {
      return grid.querySelectorAll('.' + HIDDEN_CLASS);
    }

    if (!hiddenCards().length) return;
    wrapper.hidden = false;

    button.addEventListener('click', function () {
      var cards = hiddenCards();
      var count = Math.min(perLoad, cards.length);

      for (var i = 0; i < count; i++) {
        cards[i].classList.remove(HIDDEN_CLASS);
      }

      if (count && cards[0]) {
        cards[0].setAttribute('tabindex', '-1');
        cards[0].focus({ preventScroll: true });
      }

      if (!hiddenCards().length) wrapper.hidden = true;
    });
  }

  /* === Carousel: seamless auto-scroll loop ===
     The track holds two identical halves; the animation slides it by -50%,
     so the second half lands exactly where the first began. Each half
     repeats the set enough times to cover the visible width. */
  function initCarousel(sectionEl) {
    var carousel = sectionEl.querySelector('.cwc_testimonials__carousel');
    if (!carousel) return;
    var track = carousel.querySelector('.cwc_testimonials__track');
    var set = track && track.querySelector('.cwc_testimonials__set');
    if (!set) return;
    if (carousel.dataset.cwcReady) return;
    carousel.dataset.cwcReady = 'true';

    var speed = parseFloat(carousel.dataset.speed) || 40;
    var lastWidth = 0;

    function cloneSet() {
      var clone = set.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      clone.querySelectorAll('[data-shopify-editor-block]').forEach(function (el) {
        el.removeAttribute('data-shopify-editor-block');
      });
      return clone;
    }

    function build() {
      track.querySelectorAll('.cwc_testimonials__set[aria-hidden]').forEach(function (el) {
        el.remove();
      });
      carousel.classList.remove(RUNNING_CLASS);
      if (reduceMotion.matches) return;

      var setWidth = set.offsetWidth;
      var viewWidth = carousel.offsetWidth;
      if (!setWidth || !viewWidth) return;

      var copies = Math.max(1, Math.ceil(viewWidth / setWidth));
      // First half: original + (copies - 1) clones; second half: copies clones
      for (var i = 1; i < copies * 2; i++) {
        track.appendChild(cloneSet());
      }

      var duration = (setWidth * copies) / speed;
      carousel.style.setProperty('--ts-marquee-duration', duration + 's');
      carousel.scrollLeft = 0;
      carousel.classList.add(RUNNING_CLASS);
      lastWidth = viewWidth;
    }

    build();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (carousel.offsetWidth !== lastWidth) build();
      }, 200);
    });

    if (reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', build);
    }
  }

  function initSection(sectionEl) {
    if (!sectionEl) return;
    initShowMore(sectionEl);
    initCarousel(sectionEl);
  }

  function initAllSections() {
    document.querySelectorAll('.cwc_testimonials').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.cwc_testimonials');
    if (section) initSection(section);
  });
})();
